import { TextStyle } from './text-style.model';

export class TextOverlayStateModel {
  isTyping: boolean = false;
  overlayText: string = '';
  liveText: string = '';
  textPositionX: number = 50;
  textPositionY: number = 50;
  isTextDragging: boolean = false;
  textRotation: number = 0;
  textIsGesturing: boolean = false;
  textStyle: TextStyle = {
    color: '#FFFFFF',
    fontFamily: 'Poppins, sans-serif',
    fontSize: 24
  };
  selectedColorIndex: number = 0;
  selectedFontIndex: number = 0;
  
  // Internal state
  previousTextPosition: { x: number; y: number } = { x: 50, y: 50 };
  shouldFocusContentEditable: boolean = false;
  preventBlur: boolean = true;
  
  // Tap detection
  tapStartTime: number = 0;
  tapStartX: number = 0;
  tapStartY: number = 0;

  // Available options
  readonly availableColors: string[] = [
    '#FFFFFF', // White
    '#000000', // Black
    '#FF0050', // Instagram Pink-Red
    '#FF7A00', // Orange
    '#FFD600', // Yellow
    '#00C56E', // Green
    '#00B2FF', // Light Blue
    '#4A00E0', // Deep Purple
    '#8E24AA', // Purple
    '#C51162', // Magenta
    '#795548', // Brown
    '#9E9E9E', // Medium Grey
    '#F5F5F5'  // Light Grey for soft text
  ];

  readonly availableFonts: string[] = [
    'Poppins, sans-serif',         // Custom font, if loaded via @import or <link>
    'Arial, sans-serif',           // Widely available
    'Helvetica, sans-serif',       // Default on iOS
    'Verdana, sans-serif',         // Clean, readable
    'Tahoma, sans-serif',          // Compact
    'Trebuchet MS, sans-serif',    // Friendly look
    'Georgia, serif',              // Elegant serif
    'Times New Roman, serif',      // Classic serif
    'Courier New, monospace',      // Fixed-width
    'Lucida Console, monospace',   // Terminal-style mono
    'Comic Sans MS, cursive, sans-serif', // Casual handwritten
    'Impact, Charcoal, sans-serif' // Bold, punchy
  ];

  readonly MIN_FONT_SIZE = 16;
  readonly MAX_FONT_SIZE = 96;

  reset(): void {
    this.isTyping = false;
    this.overlayText = '';
    this.liveText = '';
    this.textPositionX = 50;
    this.textPositionY = 50;
    this.isTextDragging = false;
    this.textRotation = 0;
    this.textIsGesturing = false;
    this.textStyle = {
      color: '#FFFFFF',
      fontFamily: 'Poppins, sans-serif',
      fontSize: 24
    };
    this.selectedColorIndex = 0;
    this.selectedFontIndex = 0;
    this.previousTextPosition = { x: 50, y: 50 };
    this.shouldFocusContentEditable = false;
    this.preventBlur = true;
    this.tapStartTime = 0;
    this.tapStartX = 0;
    this.tapStartY = 0;
  }

  selectColor(index: number): void {
    this.selectedColorIndex = index;
    this.textStyle.color = this.availableColors[index];
  }

  selectFont(index: number): void {
    this.selectedFontIndex = index;
    this.textStyle.fontFamily = this.availableFonts[index];
  }

  updateFontSize(fontSize: number): void {
    this.textStyle.fontSize = Math.max(
      this.MIN_FONT_SIZE,
      Math.min(this.MAX_FONT_SIZE, fontSize)
    );
  }
}

